/* Glowdle brand page: buy box, Shopify cart drawer, gallery and the live glow board. Generated by build.js. */
(function () {
  const dataEl = document.getElementById('glowdle-data');
  if (!dataEl) return;
  const D = JSON.parse(dataEl.textContent);
  document.documentElement.classList.add('js');
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ROOT = D.root.endsWith('/') ? D.root : D.root + '/';
  function money(cents) {
    const fmt = (D.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    const group = (n, dec, thou, sep) => {
      const [i, f] = n.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (f ? sep + f : '');
    };
    const n = cents / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return group(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return group(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return group(n, 0, '.', ',');
      return group(n, 2, ',', '.');
    });
  }

  const GLOWS = [
    { name: 'Pink', hex: '#FF4FD8' }, { name: 'Orange', hex: '#FF8A3D' }, { name: 'Sunshine', hex: '#FFD84A' },
    { name: 'Lime', hex: '#B8FF4A' }, { name: 'Aqua', hex: '#3DEBFF' }, { name: 'Blue', hex: '#5B8CFF' }, { name: 'Violet', hex: '#A779FF' }
  ];
  // sets 1 to 3 always exist; 4 to 6 ("Need more boards?") only when the product has those variants
  const titleOf = n => n === 1 ? '1 Glowdle' : n + ' Glowdles';
  const PACKS = {};
  [1, 2, 3, 4, 5, 6].forEach(n => {
    const v = D.variants.find(x => x.set === (n === 1 ? '1 Board' : n + ' Boards')) || (n <= 3 ? D.variants[0] : null);
    if (v) PACKS[n] = { id: v.id, price: v.price, was: v.compare, title: titleOf(n) };
  });
  const UPGRADE = PACKS[2].price - PACKS[1].price;
  // 1 board is preselected so the first price a shopper sees is the single-board price (owner, 2026-11-04)
  const state = { pack: 1 };
  let cart = { items: [], item_count: 0, total_price: 0 };

  const boardsIcon = n => Array.from({ length: Math.min(n, 3) }, (_, i) => `<span class="mini-board" style="--c:${GLOWS[[0, 4, 2][i]].hex}"></span>`).join('') + (n > 3 ? `<i class="mini-count">${n}</i>` : '');
  const setGlow = hex => document.documentElement.style.setProperty('--glow', hex);

  /* gallery */
  const track = $('#gTrack'), slides = $$('.g-slide', track);
  $('#gThumbs').innerHTML = slides.map((s, i) => `<button type="button" class="g-thumb${i ? '' : ' on'}" data-i="${i}" aria-label="Show photo ${i + 1}"><img src="${s.dataset.thumb}" alt="" loading="lazy"></button>`).join('');
  $('#gDots').innerHTML = slides.map((_, i) => `<i class="${i ? '' : 'on'}"></i>`).join('');
  addEventListener('load', () => $$('img[loading="lazy"]', track).forEach(img => { img.loading = 'eager'; }));
  const goTo = i => { i = (i + slides.length) % slides.length; track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); };
  const cur = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
  let gRaf = 0;
  track.addEventListener('scroll', () => {
    cancelAnimationFrame(gRaf);
    gRaf = requestAnimationFrame(() => {
      const i = cur();
      $$('.g-thumb').forEach((t, k) => t.classList.toggle('on', k === i));
      $$('#gDots i').forEach((d, k) => d.classList.toggle('on', k === i));
      track.parentElement.classList.toggle('info', !!slides[i] && slides[i].hasAttribute('data-info'));
    });
  }, { passive: true });
  $('#gThumbs').addEventListener('click', e => { const b = e.target.closest('.g-thumb'); if (b) goTo(+b.dataset.i); });
  $('#gPrev').addEventListener('click', () => goTo(cur() - 1));
  $('#gNext').addEventListener('click', () => goTo(cur() + 1));
  track.addEventListener('keydown', e => { if (e.key === 'ArrowRight') { e.preventDefault(); goTo(cur() + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(cur() - 1); } });

  /* buy box */
  function setPack(n) { state.pack = n; renderSummary(); }
  $$('input[name="pack"]').forEach(r => r.addEventListener('change', () => setPack(+r.value)));
  const moreBtn = $('#moreBtn');
  function openMore(on) {
    if (!moreBtn) return;
    if (!on && state.pack > 3) return; // keep a chosen 4 to 6 set visible
    moreBtn.setAttribute('aria-expanded', on);
    $('#moreSets').hidden = !on;
  }
  if (moreBtn) moreBtn.addEventListener('click', () => openMore(moreBtn.getAttribute('aria-expanded') !== 'true'));
  $('#finalPacks').addEventListener('click', e => {
    const b = e.target.closest('.fp'); if (!b) return;
    if (b.hasAttribute('data-more')) { openMore(true); $('#more').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); return; }
    setPack(+b.dataset.pack);
  });
  $$('[data-quick]').forEach(b => b.addEventListener('click', () => { setPack(+b.dataset.quick); $('#buy').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); }));

  function renderSummary() {
    const p = PACKS[state.pack];
    const total = p.price;
    $('#price').textContent = money(p.price);
    const was = $('#was'), save = $('#save');
    if (was && save) {
      const show = p.was > p.price;
      was.hidden = save.hidden = !show;
      if (show) { was.textContent = money(p.was); save.textContent = 'Save ' + Math.floor((1 - p.price / p.was) * 100) + '%'; }
    }
    $('#atcPrice').textContent = money(total);
    $('#atc2Price').textContent = money(total);
    $('#shipChip').textContent = state.pack >= D.freeShipBoards ? 'Free shipping' : `Free shipping on ${D.freeShipBoards}+`;
    $$('.pack, .mset').forEach(l => {
      const n = +l.dataset.pack, on = n === state.pack, icon = $('[data-boards]', l);
      $('input', l).checked = on; l.classList.toggle('is-on', on);
      if (icon) icon.innerHTML = boardsIcon(n);
    });
    const big = state.pack > 3, fm = $('.fp-more');
    if (moreBtn) { $('#more').classList.toggle('is-on', big); if (big) openMore(true); }
    $$('.fp').forEach(b => b.setAttribute('aria-checked', +b.dataset.pack === state.pack));
    if (fm && PACKS[4]) {
      fm.setAttribute('aria-checked', big);
      $('#fpMoreTitle').textContent = big ? p.title : '4 to 6 Glowdles';
      $('#fpMoreSub').textContent = big ? money(p.price) + (state.pack >= D.freeShipBoards ? ' · ships free' : '') : 'from ' + money(PACKS[4].price);
    }
    $('#stickyBoards').innerHTML = boardsIcon(state.pack);
    $('#stickyTitle').textContent = p.title;
    $('#stickySub').textContent = money(total) + (state.pack >= D.freeShipBoards ? ' · Free shipping' : ' · Glow pens included');
  }

  (function eta() {
    const holiday = d => {
      const m = d.getMonth(), day = d.getDate(), wd = d.getDay();
      if ((m === 0 && day === 1) || (m === 6 && day === 4) || (m === 10 && day === 11) || (m === 11 && day === 25)) return true;
      return m === 10 && wd === 4 && day >= 22 && day <= 28;
    };
    const add = n => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w && w !== 6 && !holiday(d)) k++; } return d; };
    const f = d => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    $('#eta').textContent = f(add(D.deliveryMin)) + ' – ' + f(add(D.deliveryMax));
  })();

  /* Shopify cart */
  async function request(path, body) {
    const r = await fetch(ROOT + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
    return j;
  }
  async function refreshCart() { cart = await request('cart.js'); renderCart(); }

  const isBoard = l => l.product_id === D.productId;
  const optionOf = (l, name) => ((l.options_with_values || []).find(o => o.name === name) || {}).value;
  const setSize = l => Math.max(1, parseInt(optionOf(l, 'Set'), 10) || 1);
  const boards = () => cart.items.reduce((n, l) => n + (isBoard(l) ? setSize(l) * l.quantity : 0), 0);
  const freeText = n => n === 1 ? '1 more board' : n + ' more boards';
  const sized = (url, w) => url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '';
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function renderCart() {
    const list = $('#drItems');
    if (!cart.items.length) {
      list.innerHTML = `<li class="dr-empty"><p>Your cart is empty.</p><button class="btn btn-ink" type="button" data-close>Choose your Glowdle</button></li>`;
    } else {
      list.innerHTML = cart.items.map(l => {
        const board = isBoard(l);
        const thumb = board ? boardsIcon(setSize(l)) : (l.image ? `<img src="${esc(sized(l.image, 160))}" alt="">` : '');
        const sub = board ? titleOf(setSize(l)) + ' · glow pens, cloth and USB cable'
          : [l.variant_title && l.variant_title !== 'Default Title' ? l.variant_title : '',
            ...Object.entries(l.properties || {}).filter(([k, v]) => v && k[0] !== '_').map(([k, v]) => `${k}: ${v}`)].filter(Boolean).join(' · ');
        return `
        <li class="dr-item" data-key="${esc(l.key)}" data-qty="${l.quantity}">
          <div class="dr-thumb">${thumb}</div>
          <div class="dr-info">
            <b>${esc(l.product_title)}</b>
            ${sub ? `<small>${esc(sub)}</small>` : ''}
            <div class="qty"><button type="button" data-act="dec" aria-label="Decrease quantity">−</button><span>${l.quantity}</span><button type="button" data-act="inc" aria-label="Increase quantity">+</button></div>
          </div>
          <div class="dr-price">${money(l.final_line_price)}</div>
        </li>`;
      }).join('');
    }
    const n = boards(), need = Math.max(0, D.freeShipBoards - n);
    $('#shipMsg').innerHTML = !n ? `Free shipping on ${D.freeShipBoards} or more boards.` : !need ? '<b>Free shipping unlocked.</b> Nice choice.' : `Add <b>${freeText(need)}</b> to get free shipping.`;
    $('#shipBar').style.width = Math.min(100, n / D.freeShipBoards * 100) + '%';
    const single = n === 1 && cart.items.find(l => isBoard(l) && setSize(l) === 1 && l.quantity === 1);
    let up = '';
    if (single) {
      const diff = PACKS[2].price - single.final_price;
      if (diff > 0) up = `<div class="dr-up"><div class="dr-thumb">${boardsIcon(2)}</div><div><b>Make it a 2-pack for ${money(diff)} more</b><small>One each${D.freeShipBoards <= 2 ? ', and shipping becomes free' : ''}</small></div><button type="button" data-up="pack" data-key="${esc(single.key)}">Upgrade</button></div>`;
    }
    $('#drUp').innerHTML = up;
    $('#drSub').textContent = money(cart.total_price);
    const badge = $('#cartCount');
    badge.textContent = cart.item_count; badge.classList.toggle('has', cart.item_count > 0);
    $('#cartBtn').setAttribute('aria-label', `Open cart, ${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`);
  }

  async function addCurrent(btn) {
    btn.setAttribute('aria-busy', 'true');
    try {
      await request('cart/add.js', { items: [{ id: PACKS[state.pack].id, quantity: 1 }] });
      await refreshCart();
      btn.classList.add('added');
      setTimeout(() => btn.classList.remove('added'), 1400);
      setTimeout(openCart, reduce ? 0 : 300);
    } catch (err) {
      toast(err.message);
    } finally {
      btn.removeAttribute('aria-busy');
    }
  }
  ['#atc', '#atc2', '#atc3'].forEach(id => $(id).addEventListener('click', e => addCurrent(e.currentTarget)));

  $('#drItems').addEventListener('click', async e => {
    if (e.target.closest('[data-close]')) { closeCart(); $('#buy').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); return; }
    const b = e.target.closest('[data-act]'); if (!b) return;
    const li = b.closest('.dr-item'), qty = +li.dataset.qty + (b.dataset.act === 'inc' ? 1 : -1);
    li.style.opacity = '.5';
    try { cart = await request('cart/change.js', { id: li.dataset.key, quantity: Math.max(0, qty) }); renderCart(); }
    catch (err) { li.style.opacity = ''; toast(err.message); }
  });
  $('#drUp').addEventListener('click', async e => {
    const b = e.target.closest('[data-up]'); if (!b) return;
    b.disabled = true;
    try {
      await request('cart/change.js', { id: b.dataset.key, quantity: 0 });
      await request('cart/add.js', { items: [{ id: PACKS[2].id, quantity: 1 }] });
      toast(D.freeShipBoards <= 2 ? 'Upgraded to the 2-pack. Shipping is on us.' : 'Upgraded to the 2-pack.');
      await refreshCart();
    } catch (err) {
      b.disabled = false; toast(err.message);
    }
  });

  const drawer = $('#drawer'), scrim = $('#scrim');
  let lastFocus = null;
  function openCart() { lastFocus = document.activeElement; drawer.classList.add('on'); scrim.classList.add('on'); setTimeout(() => $('#drClose').focus(), 50); }
  function closeCart() { drawer.classList.remove('on'); scrim.classList.remove('on'); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  $('#cartBtn').addEventListener('click', () => { openCart(); refreshCart().catch(() => {}); });
  $('#drClose').addEventListener('click', closeCart);
  scrim.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('on')) closeCart(); });
  $('#checkout').addEventListener('click', () => {
    if (!cart.items.length) { toast('Your cart is empty. Pick a set first.'); return; }
    location.href = ROOT + 'checkout';
  });
  addEventListener('pageshow', e => { if (e.persisted) refreshCart().catch(() => {}); });

  let tT = 0;
  function toast(msg) { const t = $('#toast'); t.textContent = msg; t.classList.add('on'); clearTimeout(tT); tT = setTimeout(() => t.classList.remove('on'), 3600); }

  /* sticky bar */
  const sticky = $('#sticky');
  let sRaf = 0;
  const syncSticky = () => {
    sRaf = 0;
    const show = $('#atc').getBoundingClientRect().bottom < 0 && $('#final').getBoundingClientRect().top > innerHeight * .8;
    if (show === sticky.classList.contains('show')) return;
    sticky.classList.toggle('show', show); sticky.setAttribute('aria-hidden', !show); $('#atc3').tabIndex = show ? 0 : -1;
  };
  addEventListener('scroll', () => { if (!sRaf) sRaf = requestAnimationFrame(syncSticky); }, { passive: true });
  addEventListener('resize', syncSticky);
  syncSticky();

  /* reviews */
  const more = $('#rvMore');
  if (more) more.addEventListener('click', () => { $('#rvGrid').classList.add('all'); more.parentElement.hidden = true; });

  /* announcement rotation */
  const msgs = $$('.annc-msg');
  if (!reduce && msgs.length > 1) {
    let ai = 0;
    setInterval(() => { msgs[ai].classList.remove('is-on'); ai = (ai + 1) % msgs.length; msgs[ai].classList.add('is-on'); }, 3800);
  }

  /* customer photos: arrows scroll the strip, a tap opens the photo large */
  const ugcTrack = $('#ugcTrack');
  if (ugcTrack) {
    const items = $$('.ugc-item', ugcTrack);
    const stepW = () => items[0].getBoundingClientRect().width + 14;
    $('#ugcPrev').addEventListener('click', () => ugcTrack.scrollBy({ left: -stepW(), behavior: reduce ? 'auto' : 'smooth' }));
    $('#ugcNext').addEventListener('click', () => ugcTrack.scrollBy({ left: stepW(), behavior: reduce ? 'auto' : 'smooth' }));
    const lb = $('#lightbox'), lbImg = $('#lbImg');
    let lbi = 0, lbLast = null;
    const showPhoto = i => {
      lbi = (i + items.length) % items.length;
      const img = $('img', items[lbi]);
      lbImg.src = img.currentSrc || img.src; lbImg.alt = img.alt;
      $('#lbCount').textContent = `${lbi + 1} / ${items.length}`;
    };
    const closeLb = () => { lb.hidden = true; document.documentElement.style.overflow = ''; if (lbLast) lbLast.focus(); };
    items.forEach((b, i) => b.addEventListener('click', () => {
      lbLast = b; showPhoto(i); lb.hidden = false; document.documentElement.style.overflow = 'hidden'; $('#lbClose').focus();
    }));
    $('#lbClose').addEventListener('click', closeLb);
    $('#lbPrev').addEventListener('click', () => showPhoto(lbi - 1));
    $('#lbNext').addEventListener('click', () => showPhoto(lbi + 1));
    lb.addEventListener('click', e => { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', e => {
      if (lb.hidden) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowRight') showPhoto(lbi + 1);
      if (e.key === 'ArrowLeft') showPhoto(lbi - 1);
    });
  }

  /* Black Friday: count down to the real Black Friday start, switch the labels when it starts, remove everything after the end */
  const BF_CFG = D.bf || { on: false };
  const bfStart = Date.parse(BF_CFG.start), bfEnd = Date.parse(BF_CFG.end);
  if (BF_CFG.on && !isNaN(bfStart) && !isNaN(bfEnd)) {
    const root = document.documentElement, timers = $$('[data-bf-timer]');
    const pad = n => String(n).padStart(2, '0');
    const bfTick = () => {
      const now = Date.now();
      root.classList.toggle('bf-on', now < bfEnd);
      root.classList.toggle('bf-live', now >= bfStart && now < bfEnd);
      if (now >= bfEnd) return false;
      const s = Math.floor(Math.max(0, bfStart - now) / 1000);
      const parts = { d: Math.floor(s / 86400), h: pad(Math.floor(s % 86400 / 3600)), m: pad(Math.floor(s % 3600 / 60)), s: pad(s % 60) };
      timers.forEach(t => $$('[data-u]', t).forEach(b => { b.textContent = parts[b.dataset.u]; }));
      return true;
    };
    if (bfTick()) { const bfIv = setInterval(() => { if (!bfTick()) clearInterval(bfIv); }, 1000); }
  }

  /* the live glow board */
  (function glowBoard() {
    const board = $('#board'), cv = $('#boardCanvas'), ctx = cv.getContext('2d');
    const PENS = ['#FF4FD8', '#FF8A3D', '#FFE14D', '#9DFF4A', '#3DEBFF', '#6E8BFF', '#B47CFF', '#FFFFFF'];
    const PEN_NAMES = ['Pink', 'Orange', 'Yellow', 'Lime', 'Aqua', 'Blue', 'Violet', 'White'];
    let pen = 0, mode = 0, W = 0, H = 0, drawing = false, last = null, demoRaf = 0, demoOn = false, cycle = 0;

    $('#penPicker').innerHTML = PENS.map((c, i) => `<button type="button" class="pen" role="radio" aria-checked="${i === pen}" aria-label="${PEN_NAMES[i]} pen" title="${PEN_NAMES[i]}" data-i="${i}" style="--c:${c}"></button>`).join('');
    $('#penPicker').addEventListener('click', e => {
      const b = e.target.closest('.pen'); if (!b) return;
      pen = +b.dataset.i;
      $$('.pen').forEach(p => p.setAttribute('aria-checked', +p.dataset.i === pen));
    });
    function setMode(i) {
      mode = (i + GLOWS.length) % GLOWS.length;
      board.style.setProperty('--glow', GLOWS[mode].hex);
      setGlow(GLOWS[mode].hex);
      $('#modeLabel').textContent = `Glow ${mode + 1} of 7`;
    }
    $('#modeBtn').addEventListener('click', () => { stopCycle(); setMode(mode + 1); });

    function size() {
      const r = board.getBoundingClientRect(), dpr = Math.min(2, window.devicePixelRatio || 1);
      W = r.width; H = r.height;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function stroke(a, b, color) {
      const lw = Math.max(4, W / 120);
      ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      ctx.shadowColor = color; ctx.shadowBlur = 18; ctx.strokeStyle = color; ctx.lineWidth = lw;
      ctx.beginPath(); ctx.moveTo(a[0], a[1]); ctx.lineTo(b[0], b[1]); ctx.stroke();
      ctx.shadowBlur = 0; ctx.strokeStyle = 'rgba(255,255,255,.72)'; ctx.lineWidth = Math.max(1.4, lw / 3);
      ctx.beginPath(); ctx.moveTo(a[0], a[1]); ctx.lineTo(b[0], b[1]); ctx.stroke();
    }
    const pt = e => { const r = cv.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
    cv.addEventListener('pointerdown', e => {
      stopDemo(); board.classList.add('used');
      drawing = true; last = pt(e); cv.setPointerCapture(e.pointerId);
      stroke(last, [last[0] + .1, last[1] + .1], PENS[pen]);
    });
    cv.addEventListener('pointermove', e => { if (!drawing) return; const p = pt(e); stroke(last, p, PENS[pen]); last = p; });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(t => cv.addEventListener(t, () => { drawing = false; }));
    $('#wipeBtn').addEventListener('click', () => {
      stopDemo();
      if (reduce) { ctx.clearRect(0, 0, W, H); return; }
      board.classList.remove('wiping'); void board.offsetWidth; board.classList.add('wiping');
      setTimeout(() => ctx.clearRect(0, 0, W, H), 380);
      setTimeout(() => board.classList.remove('wiping'), 800);
    });

    /* idle demo: a star, a heart and a little rainbow draw themselves until someone takes over */
    const shapes = () => {
      const s = Math.min(W, H);
      const star = [], heart = [], rain = [];
      for (let i = 0; i <= 10; i++) { const a = -Math.PI / 2 + i * Math.PI / 5, r = i % 2 ? s * .07 : s * .16; star.push([W * .2 + Math.cos(a) * r, H * .4 + Math.sin(a) * r]); }
      for (let i = 0; i <= 80; i++) { const t = i / 80 * Math.PI * 2, x = 16 * Math.pow(Math.sin(t), 3), y = -(13 * Math.cos(t) - 5 * Math.cos(2 * t) - 2 * Math.cos(3 * t) - Math.cos(4 * t)); heart.push([W * .5 + x * s * .0085, H * .42 + y * s * .0085]); }
      for (let i = 0; i <= 50; i++) { const t = Math.PI + i / 50 * Math.PI; rain.push([W * .8 + Math.cos(t) * s * .14, H * .58 + Math.sin(t) * s * .14]); }
      return [{ pts: interp(star, 120), c: PENS[2] }, { pts: interp(heart, 160), c: PENS[0] }, { pts: interp(rain, 90), c: PENS[4] }];
    };
    function interp(pts, n) { const out = []; for (let i = 0; i < n; i++) { const f = i / (n - 1) * (pts.length - 1), k = Math.min(pts.length - 2, Math.floor(f)), u = f - k; out.push([pts[k][0] + (pts[k + 1][0] - pts[k][0]) * u, pts[k][1] + (pts[k + 1][1] - pts[k][1]) * u]); } return out; }
    function runDemo() {
      if (demoOn) return; demoOn = true;
      const list = shapes(); let si = 0, i = 1, t0 = performance.now();
      if (reduce) { list.forEach(s => { for (let k = 1; k < s.pts.length; k++) stroke(s.pts[k - 1], s.pts[k], s.c); }); demoOn = false; return; }
      const SHAPE_MS = 1300;
      const step = now => {
        if (!demoOn) return;
        const s = list[si], target = Math.min(s.pts.length, 1 + Math.floor((now - t0) / SHAPE_MS * s.pts.length));
        for (; i < target; i++) stroke(s.pts[i - 1], s.pts[i], s.c);
        if (i >= s.pts.length) { si++; i = 1; t0 = now; if (si >= list.length) { demoOn = false; startCycle(); return; } }
        demoRaf = requestAnimationFrame(step);
      };
      demoRaf = requestAnimationFrame(step);
    }
    function stopDemo() { demoOn = false; cancelAnimationFrame(demoRaf); stopCycle(); }
    function startCycle() { if (reduce || cycle) return; cycle = setInterval(() => setMode(mode + 1), 1600); }
    function stopCycle() { clearInterval(cycle); cycle = 0; }

    size(); setMode(0);
    new ResizeObserver(() => { const w = board.getBoundingClientRect().width; if (Math.abs(w - W) > 1) { size(); } }).observe(board);
    let started = false;
    new IntersectionObserver(([e]) => { if (e.isIntersecting && !started) { started = true; runDemo(); } if (!e.isIntersecting) stopCycle(); }, { threshold: .4 }).observe(board);
  })();

  renderSummary();
  refreshCart().catch(() => {});
})();
